import { render, staticRenderFns } from "./informe-trimestral-copasst.vue?vue&type=template&id=533cdeda&"
import script from "./informe-trimestral-copasst.vue?vue&type=script&lang=js&"
export * from "./informe-trimestral-copasst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports